{
  "contributionRebalance": "Iniciar nuevo reequilibrio de contribuciones",
  "driftRebalance": "Iniciar nuevo reequilibrio de desviaciones",
  "table": {
    "createdAt": "Se ejecutó en",
    "state": "Estado",
    "files": "Archivos",
    "organization": "Organización"
  },
  "buyTradeFile": "Comprar al por mayor",
  "sellTradeFile": "Vender al por mayor",
  "mutualFundTradeFile": "Operaciones con fondos de inversión",
  "allocationFile": "Asignaciones",
  "ptfBulkTradeFile": "Archivo de comercio al por mayor PTF"
}
